export  const ADMIN_PREFRENCE_ACTION={
    RESET_ADMIN_PREFRENCE_STATE:"RESET_ADMIN_PREFRENCE_STATE",
    REQUEST_ADMIN_PREFRENCE:"REQUEST_ADMIN_PREFRENCE",
    RESPONSE_ADMIN_PREFRENCE:"RESPONSE_ADMIN_PREFRENCE",
    ERROR_ADMIN_PREFRENCE:"ERROR_ADMIN_PREFRENCE",

    RESET_ADMIN_PREFRENCE_LIST_STATE:"RESET_ADMIN_PREFRENCE_LIST_STATE",
    REQUEST_ADMIN_PREFRENCE_LIST:"REQUEST_ADMIN_PREFRENCE_LIST",
    RESPONSE_ADMIN_PREFRENCE_LIST:"RESPONSE_ADMIN_PREFRENCE_LIST",
    ERROR_ADMIN_PREFRENCE_LIST:"ERROR_ADMIN_PREFRENCE_LIST",

    RESET_ADMIN_PREFERENCE_BY_ID_STATE:"RESET_ADMIN_PREFERENCE_BY_ID_STATE",
    REQUEST_ADMIN_PREFRENCE_BY_ID:"REQUEST_ADMIN_PREFRENCE_BY_ID",
    RESPONSE_ADMIN_PREFRENCE_BY_ID:"RESPONSE_ADMIN_PREFRENCE_BY_ID",
    ERROR_ADMIN_PREFRENCE_BY_ID:"ERROR_ADMIN_PREFRENCE_BY_ID",

    RESET_ADMIN_PREFERENCE_EDIT_STATE:"RESET_ADMIN_PREFERENCE_EDIT_STATE",
    REQUEST_ADMIN_PREFERENCE_EDIT_STATE:"REQUEST_ADMIN_PREFERENCE_EDIT_STATE",
    RESPONSE_ADMIN_PREFERENCE_EDIT_STATE:"RESPONSE_ADMIN_PREFERENCE_EDIT_STATE",
    ERROR_ADMIN_PREFERENCE_EDIT_STATE:"ERROR_ADMIN_PREFERENCE_EDIT_STATE",


};

export const setResetAdminPreferenceById = () => ({
  type: ADMIN_PREFRENCE_ACTION.RESET_ADMIN_PREFERENCE_BY_ID_STATE,
  data: undefined
  });

 export const requestAdminPreferenceById = (params) =>({
  type:ADMIN_PREFRENCE_ACTION.REQUEST_ADMIN_PREFRENCE_BY_ID,
  data: params
  })
  export const responseAdminPreferenceById = (res) => ({
      type: ADMIN_PREFRENCE_ACTION.RESPONSE_ADMIN_PREFRENCE_BY_ID,
  data: res
  });

  export const errorAdminPreferenceById = (err) => ({
      type: ADMIN_PREFRENCE_ACTION.ERROR_ADMIN_PREFRENCE_BY_ID,
      data: err
      });


      export const setResetAdminPreferenceEdit = () => ({
        type: ADMIN_PREFRENCE_ACTION.RESET_ADMIN_PREFERENCE_EDIT_STATE,
        data: undefined
        });
      
       export const requestAdminPreferenceEdit = (params) =>({
        type:ADMIN_PREFRENCE_ACTION.REQUEST_ADMIN_PREFERENCE_EDIT_STATE,
        data: params
        })
        export const responseAdminPreferenceEdit = (res) => ({
            type: ADMIN_PREFRENCE_ACTION.RESPONSE_ADMIN_PREFERENCE_EDIT_STATE,
        data: res
        });
    
        export const errorAdminPreferenceEdit = (err) => ({
            type: ADMIN_PREFRENCE_ACTION.ERROR_ADMIN_PREFERENCE_EDIT_STATE,
            data: err
            });

export const setResetAdminPreferenceState = () => ({
    type: ADMIN_PREFRENCE_ACTION.RESET_ADMIN_PREFRENCE_STATE,
    data: undefined
  });
  
  export const requestAdminPreference = (params) =>({
    type:ADMIN_PREFRENCE_ACTION.REQUEST_ADMIN_PREFRENCE,
    data: params
  })
  export const responseAdminPreference = (res) => ({
    type: ADMIN_PREFRENCE_ACTION.RESPONSE_ADMIN_PREFRENCE,
    data: res
  });
  
  export const errorAdminPreference = (err) => ({
    type: ADMIN_PREFRENCE_ACTION.ERROR_ADMIN_PREFRENCE,
    data: err
  });

  export const setResetAdminPreferenceListState = () => ({
    type: ADMIN_PREFRENCE_ACTION.RESET_ADMIN_PREFRENCE_LIST_STATE,
    data: undefined
    });
  
   export const requestAdminPreferenceList = (params) =>({
    type:ADMIN_PREFRENCE_ACTION.REQUEST_ADMIN_PREFRENCE_LIST,
    data: params
    })
    export const responseAdminPreferenceList = (res) => ({
        type: ADMIN_PREFRENCE_ACTION.RESPONSE_ADMIN_PREFRENCE_LIST,
    data: res
    });

    export const errorAdminPreferenceList = (err) => ({
        type: ADMIN_PREFRENCE_ACTION.ERROR_ADMIN_PREFRENCE_LIST,
        data: err
        });
